import api from "@/services/api";

export default {
  fetchProjects() {
    return api.get(`project/`);
  },
  fetchData() {
    return api.get(`project/`).then(response => response.data);
  },
  getProjectStakeholdersWithSurveys(pk) {
    api.defaults.timeout = 30000
    return api.get(`project/get_project_stakeholders_and_surveys/?pk=${pk}`)
  },
  getProjectConversations(pk) {
    api.defaults.timeout = 30000
    return api.get(`project/get_project_conversations/?pk=${pk}`)
  }
};
